import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Sidebar from '../../components/Sidebar/Sidebar';
import { Button, Modal, Box, TextField } from '@mui/material';
import './Gestores.css';

const apiUrl = process.env.REACT_APP_API_URL;

function Gestores() {
  const [gestores, setGestores] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [editingGestor, setEditingGestor] = useState(null);
  const [formValues, setFormValues] = useState({ name: '' });
  const [isSidebarOpen, setSidebarOpen] = useState(true);

  // Fetch gestores
  useEffect(() => {
    axios
      .get(`${apiUrl}/gestores`)
      .then((response) => setGestores(response.data))
      .catch((error) => console.error('Erro ao buscar os gestores:', error));
  }, []);

  // Abre o modal
  const handleOpenModal = (gestor = null) => {
    setEditingGestor(gestor);
    setFormValues(gestor ? { name: gestor.name } : { name: '' });
    setOpenModal(true);
  };

  // Fecha o modal
  const handleCloseModal = () => {
    setOpenModal(false);
    setEditingGestor(null);
    setFormValues({ name: '' });
  };

  // Salvar/Editar Gestor
  const handleSave = () => {
    const endpoint = editingGestor
      ? `${apiUrl}/gestores/${editingGestor.id}`
      : `${apiUrl}/gestores`;
    const method = editingGestor ? 'put' : 'post';

    axios[method](endpoint, formValues)
      .then((response) => {
        if (editingGestor) {
          setGestores((prev) =>
            prev.map((item) => (item.id === response.data.id ? response.data : item))
          );
        } else {
          setGestores((prev) => [...prev, response.data]);
        }
        handleCloseModal();
      })
      .catch((error) => console.error('Erro ao salvar:', error));
  };

  // Deletar Gestor
  const handleDelete = (id) => {
    if (window.confirm('Tem certeza que deseja excluir?')) {
      axios
        .delete(`${apiUrl}/gestores/${id}`)
        .then(() => setGestores((prev) => prev.filter((item) => item.id !== id)))
        .catch((error) => console.error('Erro ao deletar:', error));
    }
  };

  // Toggle da Sidebar
  const toggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className="gestores-container">
      <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
      <div className={`content ${isSidebarOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
        <div className="header">
          <h2>Gestores</h2>
          <Button
            variant="contained"
            className="custom-add-button"
            onClick={() => handleOpenModal()}
          >
            + Adicionar
          </Button>
        </div>
        <table className="custom-table">
          <thead>
            <tr>
              <th>Nome</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {gestores.map((gestor) => (
              <tr key={gestor.id}>
                <td>{gestor.name}</td>
                <td className="action-column">
                  <Button
                    variant="text"
                    color="primary"
                    onClick={() => handleOpenModal(gestor)}
                  >
                    Editar
                  </Button>
                  <Button
                    variant="text"
                    color="error"
                    onClick={() => handleDelete(gestor.id)}
                  >
                    Excluir
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* Modal */}
        <Modal open={openModal} onClose={handleCloseModal}>
          <Box className="modal-box">
            <h2>{editingGestor ? 'Editar Gestor' : 'Adicionar Gestor'}</h2>
            <TextField
              label="Nome"
              variant="outlined"
              fullWidth
              value={formValues.name}
              onChange={(e) => setFormValues({ ...formValues, name: e.target.value })}
              margin="normal"
            />
            <div className="modal-actions">
              <Button className="custom-save-button" onClick={handleSave}>
                Salvar
              </Button>
              <Button className="custom-cancel-button" onClick={handleCloseModal}>
                Cancelar
              </Button>
            </div>
          </Box>
        </Modal>
      </div>
    </div>
  );
}

export default Gestores;
